import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
  selector: '[appEmailValidation]'
})
export class EmailValidationDirective {

  constructor() { }

}

export function confirmEmailValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
     let primaryEmailVal = form.controls['primaryEmail'].value;
     if (primaryEmailVal) {
       return null;
      // if (primaryEmailVal === control.value) {
      //   return { 'confirmEmailValidation': { value: control.value } };
      // } else {
      //   return null;
      // }
     } else {
       return null;
     }
    } else {
      return null;
    }
  };
}
